export default {
  operateReport: {
    title: '经营报表',
    description: '查看经营资金与销售数据，支持多维度分析。',
    summaryTitle: '资金汇总',
    dimensionSummary: '按维度查看经营数据',
    filters: {
      shop: '门店名称',
      shopGroup: '门店组',
      businessDate: '营业日',
      productName: '商品名称',
      productType: '商品类型',
      backendCategory: '后台分类',
      frontCategory: '前台分类',
      salesChannel: '售卖渠道',
      payChannel: '支付渠道',
    },
    dimensions: {
      store: '按门店',
      product: '按商品',
      productType: '按商品类型',
      backendCategory: '按后台分类',
      frontCategory: '按前台分类',
      salesChannel: '按售卖渠道',
      payChannel: '按支付渠道',
    },
    codes: {
      salesChannel: {
        3: '桌面收银机',
        4: '小程序',
      },
      payChannel: {
        CASH: '现金',
        WECHAT: '微信',
        ALIPAY: '支付宝',
        QQPAY: 'QQ支付',
        UNIPAY: '云闪付',
        BESTPAY: '翼支付',
        JDPAY: '京东支付',
        DIGICCY: '数字货币',
      },
    },
    columns: {
      name: '名称',
      shopGroup: '门店组',
      receiptAmount: '实际资金收款',
      refundAmount: '实际资金退款',
      netAmount: '实际资金净收',
      salesAmount: '销售金额',
      salesRefundAmount: '订单退款金额',
      netSales: '净销售额',
      saleQuantity: '销售数量',
      refundQuantity: '退款数量',
      paymentOrderCount: '支付完成订单数',
      paymentCount: '成功支付笔数',
      refundOrderCount: '已完成售后单数',
      ratio: '占比',
    },
    quickRange: '快捷范围',
    today: '今天',
    lastThreeDays: '近三天',
    lastWeek: '近一周',
    lastMonth: '近一个月',
    yesterday: '昨天',
    lastSevenDays: '最近7天',
    thisMonth: '本月',
    rangeHint: '营业日 {start} 至 {end}（含首尾）；租户时区：{timeZone}',
    loading: '正在加载经营报表',
    loadFailed: '经营报表加载失败，请重试。',
    retry: '重新加载',
    empty: '当前条件下暂无经营数据',
    validation: {
      dateRequired: '请选择开始和结束营业日',
      dateInvalid: '请输入有效的营业日，格式为 YYYY-MM-DD',
      dateOrder: '结束营业日不能早于开始营业日',
      productNameLimit: '商品名称不能超过50个字符',
      keywordLimit: '筛选内容不能超过100个字符',
    },
    total: '合计',
    currencySymbol: '¥',
    specification: '商品规格',
    optionsFailed: '筛选选项加载失败，请重试。',
    retryOptions: '重新加载选项',
    help: {
      payChannel: {
        name: '按成功支付明细的支付渠道汇总；组合支付分别归入各渠道，退款按对应退款渠道归集。',
        receipt: '所选营业日范围内，整单成功订单的实际资金收款；按当前维度汇总，退款单独列示。组合支付按对应支付明细归集，不重复计入整单金额。',
        refund: '所选营业日退款成功的实际资金。审批通过或处理中不计；线上以渠道最终成功为准，不以客户银行到账日归属。现金退款提交成功即计入。包含跨日退款，不回写原销售日。',
        net: '实际资金净收 = 实际资金收款 - 实际资金退款；与顶部卡片同口径，允许负数。',
        paymentCount: '所选营业日范围内，收款完成订单在该支付渠道的成功支付记录笔数。组合支付按渠道分别统计，笔数不等于去重订单数；退款不冲减原支付笔数。',
        ratio: '占比 = 本行净收金额 ÷ 当前页签筛选结果的净收金额合计 × 100%。分母包含全部分页数据，不仅是当前页；合计为0时显示“—”。',
      },
      salesChannel: {
        name: '按订单来源的售卖渠道汇总，区别于顾客付款使用的支付渠道。',
        receipt: '所选营业日范围内，整单成功订单的实际资金收款；按当前维度汇总，退款单独列示。组合支付按对应支付明细归集，不重复计入整单金额。',
        refund: '所选营业日退款成功的实际资金。审批通过或处理中不计；线上以渠道最终成功为准，不以客户银行到账日归属。现金退款提交成功即计入。包含跨日退款，不回写原销售日。',
        net: '实际资金净收 = 实际资金收款 - 实际资金退款；与顶部卡片同口径，允许负数。',
        paymentOrderCount: '所选营业日范围内，收款完成的销售订单数，订单去重计数。同一订单多笔支付只计一单，后续退款不冲减原销售订单数。',
        refundOrderCount: '所选期间内退款成功的售后订单数量，按退款成功营业日统计。同一销售订单的不同售后订单分别计数，同一售后订单只计一次。审批通过不计；线上以渠道最终成功为准，现金以退款提交成功为准。',
        ratio: '占比 = 本行净收金额 ÷ 当前页签筛选结果的净收金额合计 × 100%。分母包含全部分页数据，不仅是当前页；合计为0时显示“—”。',
      },
      product: {
        name: '按订单商品的总部 SKU 汇总，展示商品名称，同名商品通过规格区分。',
        saleQuantity: '所选营业日范围内，收款完成订单中对应商品的销售数量之和。退款数量单独统计，不冲减原销售数量。',
        sales: '所选营业日范围内，收款完成订单中对应商品的实际销售金额，已扣除优惠、折扣。退款金额另列；部分收款、取消及支付失败订单不计入。',
        refundQuantity: '所选营业日范围内，退款成功记录对应的退货商品数量之和，按退款成功营业日统计；不冲减销售数量。',
        salesRefund: '订单成功退款金额，按退款成功营业日归属。',
        netSales: '净销售额 = 销售金额 - 订单退款金额。销售归整单成功营业日，退款归退款成功营业日，允许负数。',
        ratio: '占比 = 本行净销售额 ÷ 当前页签筛选结果的净销售额合计 × 100%。分母包含全部分页数据，不仅是当前页；合计为0时显示“—”。',
      },
      store: {
        name: '按销售归属门店汇总，展示门店名称。',
        shopGroup: '按门店统计时展示门店所属的门店组。',
        receipt: '所选营业日范围内，整单成功订单的实际资金收款；按当前维度汇总，退款单独列示。组合支付按对应支付明细归集，不重复计入整单金额。',
        refund: '所选营业日退款成功的实际资金。审批通过或处理中不计；线上以渠道最终成功为准，不以客户银行到账日归属。现金退款提交成功即计入。包含跨日退款，不回写原销售日。',
        net: '实际资金净收 = 实际资金收款 - 实际资金退款；与顶部卡片同口径，允许负数。',
        paymentOrderCount: '所选营业日范围内，收款完成的销售订单数，订单去重计数。同一订单多笔支付只计一单，后续退款不冲减原销售订单数。',
        refundOrderCount: '所选期间内退款成功的售后订单数量，按退款成功营业日统计。同一销售订单的不同售后订单分别计数，同一售后订单只计一次。审批通过不计；线上以渠道最终成功为准，现金以退款提交成功为准。',
        ratio: '占比 = 本门店净收金额 ÷ 当前页签筛选结果的净收金额合计 × 100%。分母包含全部分页数据，不仅是当前页；合计为0时显示“—”。',
      },
      receipt: '当前有效筛选范围内的实际资金收款金额。',
      refund: '已完成售后的实际资金退款金额，归属售后完成营业日。',
      net: '实际资金收款减实际资金退款，允许为负数。顶部为资金汇总，分类重复归集时表格合计可能高于顶部金额。',
      sales: '已确认结账的商品销售金额。',
      salesRefund: '已完成售后的退款金额，归属售后更新时间所在营业日。',
      netSales: '销售金额减订单退款金额，允许为负数。分类存在重复归集时，分类合计可能高于顶部资金汇总。',
      saleQuantity: '已确认结账的销售商品件数。',
      refundQuantity: '已完成售后对应的退款商品件数，归属售后完成营业日。',
      paymentOrderCount: '当前维度内支付完成的去重订单数；同一订单可计入不同支付渠道。',
      paymentCount: '成功支付记录数；同一订单在同一渠道发生多笔支付时分别计数。',
      refundOrderCount: '已完成售后单数；同一原订单发生多次已完成售后时分别计数。',
      ratio: '当前行净额占筛选后全量列表净额的比例，分母为0时显示横线。',
      shopGroup: '按门店统计时展示门店所属的门店组。',
      sku: '按总部 SKU 分别统计，同名商品通过规格区分。',
      categories: '分类可能重复归集；合计为筛选后全量结果，不受分页影响，可能高于顶部资金汇总。',
    },
  },
};
